import {
  Box,
  Typography,
  Container,
  useTheme,
  useMediaQuery,
} from "@mui/material";

const PrivacyPolicyDoc = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const sectionStyle = {
    marginBottom: theme.spacing(4),
  };

  const headingStyle = {
    fontWeight: 500,
    marginBottom: theme.spacing(1),
    fontFamily: "Outfit",
  };

  const paragraphStyle = {
    marginBottom: theme.spacing(1.2),
    fontFamily: "Outfit",
  };

  return (
    <Box
      sx={{
        backgroundColor: "white",
        fontFamily: "Outfit",
        // marginTop: "4%",
      }}
    >
      <Container maxWidth="md">
        <Typography
          variant="h4"
          sx={{ fontWeight: 550, mb: 1, fontFamily: "Outfit" }}
        >
          Privacy Policy
        </Typography>

        <Typography sx={paragraphStyle}>
          Effective Date: July 01, 2025
        </Typography>

        <Typography sx={paragraphStyle}>
          Thank you for visiting Atttic.com (“Website”), operated by Xculptor
          3Dtech Private Limited (“Company”, “we”, “us”, or “our”). We are
          committed to protecting your privacy and ensuring your personal
          information is handled in a safe and responsible manner.
        </Typography>

        <Typography sx={paragraphStyle}>
          This Privacy Policy explains how we collect, use, disclose, and
          safeguard your information when you visit our Website.
        </Typography>

        {[
          {
            title: "1. Information We Collect",
            body: `a) Information You Provide

We may collect personal information that you voluntarily provide to us when you fill out forms on the Website, including:

- Name
- Email address
- Phone number
- Company name
- Details about your inquiry or requirements
- Any other information you choose to provide

b) Information Collected Automatically

When you access or use our Website, we may automatically collect certain information, including:

- IP address
- Browser type and version
- Device identifiers
- Operating system
- Referring website
- Pages you visit and the dates/times of your visits
- Clickstream data

We collect this information using cookies, web beacons, and similar tracking technologies. You can manage your cookie preferences through your browser settings or by using any consent tools we may provide.`,
          },
          {
            title: "2. How We Use Your Information",
            body: `We use your personal information to:

- Provide and maintain our Website and services
- Respond to your inquiries and provide requested information
- Communicate with you, including sending marketing and promotional materials
- Improve our Website, services, and user experience
- Analyze usage and trends to enhance the Website’s performance and effectiveness
- Comply with legal obligations and protect our legal rights`,
          },
          {
            title: "3. Marketing Communications",
            body: `With your consent where required, we may use your contact information to send you marketing emails, newsletters, and promotional messages about Atttic’s services and offerings.

You can opt out of receiving marketing communications at any time by:

- Clicking the “unsubscribe” link in our emails
- Replying with “STOP” or similar keywords in messaging platforms (e.g., WhatsApp or SMS), where applicable
- Contacting us directly at swapnil.kokal@atttic.com

We will process your request promptly and stop sending you marketing messages.`,
          },
          {
            title: "4. Sharing of Information",
            body: `We do not sell your personal information to third parties.

We may share your information with:

- Employees and authorized contractors of Xculptor 3Dtech Private Limited who need it to fulfill the purposes outlined in this Policy
- Service providers and partners who assist us in operating our Website and delivering services (such as email services, analytics providers, or IT support), subject to strict confidentiality obligations
- Government authorities or other parties when required to comply with legal obligations or to protect our rights and safety

We will not share your personal information with other third parties without your consent.`,
          },
          {
            title: "5. Data Security",
            body: `We implement appropriate technical and organizational measures to safeguard your personal information. However, please be aware that no security measures are completely foolproof.`,
          },
          {
            title: "6. Data Retention",
            body: `We retain your personal information only as long as necessary to fulfill the purposes outlined in this Policy, unless a longer retention period is required or permitted by law.`,
          },
          {
            title: "7. Your Rights",
            body: `Depending on your jurisdiction, you may have rights regarding your personal data, including:

- The right to access, correct, or delete your information
- The right to restrict or object to certain processing
- The right to withdraw consent at any time
- The right to lodge a complaint with a data protection authority

To exercise these rights, please contact us at contactus@atttic.com`,
          },
          {
            title: "8. International Transfers",
            body: `Your information may be transferred to and processed in countries outside your own, which may have different data protection laws. By using our Website, you consent to such transfers, provided we ensure appropriate safeguards are in place to protect your data.`,
          },
          {
            title: "9. Changes to This Privacy Policy",
            body: `We may update this Privacy Policy from time to time to reflect changes in our practices or legal requirements. We will post any updates on this page with a new effective date. We encourage you to review this Policy periodically.`,
          },
          {
            title: "10. Contact Us",
            body: `If you have any questions or concerns about this Privacy Policy or our data practices, please contact us at contactus@atttic.com`,
          },
        ].map((section, index) => (
          <Box key={index} sx={sectionStyle}>
            <Typography variant="h6" sx={headingStyle}>
              {section.title}
            </Typography>
            {section.body.split("\n").map((line, idx) => (
              <Typography key={idx} sx={paragraphStyle}>
                {line.trim()}
              </Typography>
            ))}
          </Box>
        ))}
      </Container>
    </Box>
  );
};

export default PrivacyPolicyDoc;
